import type { SocialTasksSnapshot } from "../features/social-tasks/state/social-tasks-controller"
import type { ReferralStatus } from "../features/referrals/api/referral-schemas"

export const TASKS_READ_MAX_AGE = 30_000
export type SocialTasksRead = Pick<
  SocialTasksSnapshot,
  "catalog" | "connection" | "connectionVerified" | "rows" | "progressFresh"
>

/** One read snapshot per feature, owned by the live runtime; never persisted. */
export class ScopedReadCache<T> {
  private entry: {
    key: string
    data: T
    readAt: number
    valid: boolean
  } | null = null

  read(key: string) {
    if (this.entry?.key !== key) {
      this.clear()
      return null
    }
    const age = Date.now() - this.entry.readAt
    return {
      ...this.entry,
      fresh: this.entry.valid && age >= 0 && age < TASKS_READ_MAX_AGE,
    }
  }
  write(key: string, data: T, readAt = Date.now()) {
    this.entry = { key, data, readAt, valid: true }
  }
  invalidate() {
    if (this.entry) this.entry.valid = false
  }
  clear() {
    this.entry = null
  }
}

export class TasksReadCache {
  readonly socialTasks = new ScopedReadCache<SocialTasksRead>()
  readonly referral = new ScopedReadCache<ReferralStatus>()
  private context: string | null = null
  syncContext(context: string) {
    if (context !== this.context) {
      this.clear()
      this.context = context
    }
  }
  clear() {
    this.socialTasks.clear()
    this.referral.clear()
  }
}
